import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AxiosResponse } from "axios";
import { DeleteBankResponseSchema } from "../response/DeleteBankResponse";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";

interface DeleteBankData {
    id: string;
}

export const useDeleteBank = () => {
    return useMutation({
        mutationKey: ['banks', 'delete'],
        mutationFn: async (formData: DeleteBankData) => privateApi.delete(`/v3/property-bank/${formData.id}`),
        onSuccess: async (response: AxiosResponse) => {
            const validationResult = DeleteBankResponseSchema.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid bank data format");
            }

            return validationResult.data;
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid bank data format");
            } else {
                console.error(`Failed to delete bank`, error);
                throw error;
            }
        }
    })
}